module.exports = __webpack_public_path__ + "img/vincent.854eb4eb.png";